import React, { useEffect, useRef } from 'react';
import { Container, Violator } from '@hpi-sox/hpstellar-core';
import Typography from '@hpi-sox/hpstellar-core/visId/Typography';
import StockIndicator from '../pdp-details/stock-indicator';
import PriceBlock from '../../components-v2/pdp-details/price-block';
import CTA from '../../components-v2/pdp-details/cta';
import Sku from '../../components-v2/pdp-details/sku';
import { ProductTitle } from '../pdp-details/title-section';
import DeliveryMessage from '../pdp-details/pdp-delivery-message';
import ConsumerFinanceWidget from '../../../product/components/consumer-finance-widget';
import { ReviewSection } from '../pdp-details/title-section';
import PriceBlockV2 from '../pdp-details/product-hero-container/price-container';
import AllianceBadge from '../../../product/components/alliance-badge';

import './shadow-header.less';

export default ({ pdpShadowCTO, productInitial, bazaarVoiceProps = {}, v2 }) => {
    const { shadowCTOEnabled } = pdpShadowCTO || {};

    //if v2 add intersection observer to mark shadow header as pinned once the position sticky is applied
    const shadowHeaderRef = useRef(null);
    useEffect(() => {
        if (v2 && shadowHeaderRef.current) {
            const observer = new IntersectionObserver(
                ([e]) => {
                    e.target.classList.toggle('is-pinned', e.intersectionRatio < 1);
                    /* if (e.intersectionRatio > 1) {
                        e.target.classList.remove('is-pinned');
                    } else {
                        e.target.classList.add('is-pinned');
                    }*/
                },
                { threshold: [1] },
            );
            observer.observe(shadowHeaderRef.current);
            return () => observer.disconnect();
        }
    }, [v2]);

    if (!shadowCTOEnabled) {
        return null;
    }
    const { shipDate, HPFinance_Promo, enrollmentKit } = productInitial;
    const { overviewAttributes, facet_aipc, dte_facet_OS } = productInitial || EMPTY_OBJ;
    const { nextGenTagline } = overviewAttributes || EMPTY_OBJ;
    const msrpTooltipProps = { position: 'bottom-start' };

    return (
        <div className={`shadowHeaderContainer${v2 ? ' v2' : ''}`} ref={shadowHeaderRef}>
            <Container>
                <div class="shadowHeader">
                    <div className="product-container">
                        {v2 && (
                            <ReviewSection
                                productInitial={productInitial}
                                bazaarVoiceProps={bazaarVoiceProps}
                                shadowCTO
                            />
                        )}
                        <ProductTitle typographyProps={{ variant: 'titleM' }} />
                        <AllianceBadge aiBadgeKey={facet_aipc} osBadgeKey={dte_facet_OS} />
                        {v2 && nextGenTagline && (
                            <Typography className="title-tagline" variant="caption">
                                {nextGenTagline}
                            </Typography>
                        )}
                        {!v2 && (
                            <div className="inventory-row">
                                <StockIndicator
                                    stockIndicatorProps={{ size: 'small', messagesOrientation: 'horizontal' }}
                                    shipDate={shipDate}
                                />
                                <div className="spacer">{'|'}</div>
                                <Sku />
                            </div>
                        )}
                    </div>
                    <div className="price-container">
                        <div className={HPFinance_Promo ? 'finance-container' : ''}>
                            {!enrollmentKit && (
                                <>
                                    {v2 ? (
                                        <PriceBlockV2
                                            hasPriceSeoText={false}
                                            className="sto-pdp-price-row"
                                            msrpTooltipProps={msrpTooltipProps}
                                        />
                                    ) : (
                                        <PriceBlock />
                                    )}
                                </>
                            )}
                            <ConsumerFinanceWidget product={productInitial} />
                        </div>
                        <div className={v2 ? 'cta-container' : undefined}>
                            <CTA />
                            {v2 && (
                                <StockIndicator
                                    stockIndicatorProps={{ size: 'small', messagesOrientation: 'horizontal' }}
                                    shipDate={shipDate}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};
